"use strict";
'app public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var IrcdDiffs = _interopRequireWildcard(require("@/helpers/IrcdDiffs"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const basicBanListSorter = (a, b) => {
  if (a.banned_at === b.banned_at) {
    return Misc.strCompare(a.banned, b.banned);
  }
  return b.banned_at - a.banned_at;
};
const getBanListSorter = extban => {
  if (!extban) {
    return basicBanListSorter;
  }
  const extbanColon = extban + ':';
  return (a, b) => {
    const aAccount = a.banned.indexOf(extbanColon) === 0;
    const bAccount = b.banned.indexOf(extbanColon) === 0;
    if (aAccount && !bAccount) {
      return -1;
    }
    if (!aAccount && bAccount) {
      return 1;
    }
    return basicBanListSorter(a, b);
  };
};
var _default = exports.default = {
  props: ['buffer'],
  data() {
    return {
      banMask: '',
      banList: [],
      is_refreshing: false,
      clickUpdateTimeout: 0
    };
  },
  computed: {
    extban() {
      return IrcdDiffs.extbanAccount(this.buffer.getNetwork());
    },
    areWeAnOp() {
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    sortedBanList() {
      const sorter = getBanListSorter(this.extban);
      return this.banList.slice().sort(sorter);
    }
  },
  watch: {
    buffer() {
      this.banList = [];
      this.is_refreshing = false;
      this.clickUpdateTimeout = 0;
      this.updateBanlist();
    }
  },
  created() {
    this.listen(this.$state, 'irc.mode', (event, network) => {
      if (network !== this.buffer.getNetwork()) {
        return;
      }
      if (!network.ircClient.caseCompare(event.target, this.buffer.name)) {
        return;
      }
      event.modes.forEach(change => {
        if (change.mode.length !== 2 || change.mode[1] !== 'b') {
          return;
        }
        if (change.mode[0] === '+') {
          this.banList.push({
            banned: change.param,
            banned_at: Math.floor(event.time / 1000),
            banned_by: event.nick,
            channel: event.target
          });
        } else if (change.mode[0] === '-') {
          this.banList = this.banList.filter(ban => ban.banned !== change.param);
        }
      });
    });
    this.updateBanlist();
  },
  methods: {
    displayMask(banMask) {
      return banMask.replace(this.extban + ':', '');
    },
    clickUpdateBanlist() {
      if (this.clickUpdateTimeout) {
        return;
      }
      this.clickUpdateTimeout = setTimeout(() => {
        this.clickUpdateTimeout = 0;
      }, 4000);
      this.updateBanlist();
    },
    updateBanlist() {
      if (this.is_refreshing || this.buffer.getNetwork().state !== 'connected') {
        return;
      }
      const channelName = this.buffer.name;
      const network = this.buffer.getNetwork();
      this.is_refreshing = true;
      network.ircClient.banlist(channelName, event => {
        const currentNetwork = this.buffer.getNetwork();
        const bufferMatches = currentNetwork.ircClient.caseCompare(this.buffer.name, event.channel);
        if (!bufferMatches || network !== currentNetwork) {
          // The buffer or network changed since making the request
          return;
        }
        this.banList = event.bans;
        this.is_refreshing = false;
      });
    },
    addBan() {
      const mask = this.banMask.trim();
      if (!mask) {
        return;
      }
      const ircClient = this.buffer.getNetwork().ircClient;
      ircClient.ban(this.buffer.name, mask);
      this.banMask = '';
    },
    removeBan(mask) {
      const channelName = this.buffer.name;
      this.buffer.getNetwork().ircClient.unban(channelName, mask);
    },
    banKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.addBan();
      }
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["ChannelBanlist"]
window._app_exports.components.ChannelBanlist = exports.default ? exports.default : exports;
